import { render, staticRenderFns } from "./AssessmentListSection.vue?vue&type=template&id=7c169479"
import script from "./AssessmentListSection.vue?vue&type=script&lang=js"
export * from "./AssessmentListSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports